/**
 * Buat fetch data di dir service semua
 *
 */

import { formatDate } from "@/lib/utils";
import IAsset from "@/models/asset/Asset";
import { isErrorWithMessage } from "@/models/helper/ErrorWithMessage";
import { PaginatedResponse } from "@/models/helper/Response";
import { UserFacingError } from "@/models/helper/UserFacingError";
import { ITeamMember } from "@/models/user/TeamMember";
import axios, { isAxiosError } from "axios";

export default class BorrowingService {
  static async getAssetByRooms(
    rooms: string[],
    page: number,
    search?: string
  ): Promise<PaginatedResponse<IAsset[]>> {
    try {
      const res = await axios.get(
        import.meta.env.VITE_API_URL + "borrowing/student/assets",
        {
          params: {
            page: page,
            rooms: rooms,
            search: search,
          },
        }
      );

      return res.data.data;
    } catch (error) {
      console.error(error);
      throw new UserFacingError({
        title: "Fetch error.",
        description: "Failed to fetch list of borrowable assets.",
      });
    }
  }
  
  static async submitBorrowing(
    submissionRole: "student" | "staff",
    date: Date,
    roomId: number | string,
    shifts: number[],
    borrowingReasonCategory: string,
    purpose: string,
    needInternet: boolean | null,
    studentNimLeader: string,
    borrowerEmail: string,
    borrowerPhoneNumber: string,
    isPrivate: boolean,
    needChemicals?: boolean,
    team?: ITeamMember[],
    assets?: IAsset[],
    pcCount?: number,
    requestedMaterials?: { itemId: number; requestAmount: number | string }[],
    accessToken?: string
  ) {
    try {
      const res = await axios.post(
        import.meta.env.VITE_API_URL + `borrowing/${submissionRole}/submit`,
        {
          date: formatDate(date),
          room_id: roomId,
          shifts: shifts,
          borrowing_reason_category: borrowingReasonCategory,
          purpose: purpose,
          need_internet: needInternet,
          need_chemicals: needChemicals,
          assets: assets?.map((asset) => asset.id),
          team: team,
          student_nim_leader: studentNimLeader,
          borrower_email: borrowerEmail,
          borrower_phone_number: borrowerPhoneNumber,
          is_private: isPrivate,
          pc_count: pcCount || 0,
          requested_materials: needChemicals ? requestedMaterials?.map((item) => ({
            itemId: item.itemId,
            requestAmount: Number(item.requestAmount),
          })) : [],
        },
        {
          withCredentials: true,
          headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
        }
      );

      if (res.data.data.status !== 1) {
        throw new Error(res.data.data.message);
      }

      return res.data.data;
    } catch (error) {
      console.error(error);
      if (isAxiosError(error)) {
        const errPayload = error.response?.data?.errors;
        const desc = typeof errPayload === "object" && errPayload?.message
          ? errPayload.message
          : typeof errPayload === "string"
            ? errPayload
            : error.response?.data?.message && error.response?.data?.message !== "failed"
              ? error.response.data.message
              : "An unknown error occurred.";

        throw new UserFacingError({
          title: "Submit borrowing error.",
          description: desc,
        });
      }
      throw new UserFacingError({
        title: "Submit borrowing error.",
        description: isErrorWithMessage(error)
          ? error.message
          : "An unknown error occurred.",
      });
    }
  }
}
